/**
 * Chức năng thực hiện trên CellEditor
 * dtnga3 (22.05.2023)
 */
export default {
  CopyUpRow: 1, // Sao chép lên trên
  CopyDownRow: 2, // Sao chép xuống dưới
  CopyRow: 3 // DTQUOC(20.10.2023) Sao chép dữ liệu tất cả các dòng
};
